import React from 'react'
import profileBanner from '../../Assets/images/profile-bnr.webp'
import { useState, useEffect } from 'react'
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import { toast } from 'react-toastify'
import { imageExtentionSupport } from '../../utils/Helper'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import profileValidation from '../../Validation/Profilevaalidation'
import { ApiTypes } from '../../constants/Constants'
import { ProfileAction } from '../../redux/Action/Authaction'
import { useDispatch } from 'react-redux'
import CommanPhoneNumber from '../layout/CommanPhoneNumber'
import FrontLoader from '../layout/FrontLoader'
import { LanguageConstants } from '../../constants/LanguageConstants'
import { Modal } from 'react-bootstrap'
import VerfiyOtpEmail from '../../Modal/VerfiyOtpEmail'

interface FormInputs {
  name: string;
  email: string;
  phone_number: string;
  phone_country_code: string
};
function Profile() {
  const profile = useMakeRequest()
  const VerifyEmail = useMakeRequest()
  const profileUpdate = useMakeRequest()
  const [image, setImage] = useState("");
  const [showimage, setShowImage] = useState('')
  const dispatch = useDispatch()
  const [verfiy, setVerfiy] = useState(false)
  const [otpShow, setOtpShow] = useState(false)
  const [initialData, setInitialData] = useState<any>({});
  const [isChanged, setIsChanged] = useState(false);


  const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
    mode: 'onChange',
    resolver: yupResolver(profileValidation),
  });
  useEffect(() => {
    profile.makeRequest({ url: ApiConstants?.Profile, toastStatus: false })
  }, [profileUpdate.status])
  const onSubmit = (data: FormInputs) => {
    if (verfiy) {
      toast.error(LanguageConstants?.VERFIY_EMAIL)
    } else {
      var payload
      if (!image) {
        payload = {
          email: data?.email,
          name: data?.name?.trim(),
          phone_number: data?.phone_number,
          phone_country_code: data?.phone_country_code
        }
      } else {
        payload = {
          email: data?.email,
          name: data?.name?.trim(),
          phone_number: data?.phone_number,
          profile_pic: image,
          phone_country_code: data?.phone_country_code

        }
      }
      profileUpdate.makeRequest({ payload, type: ApiTypes.POSTAPIFORMDATA, url: ApiConstants?.UpdateProfile, toastStatus: true })
    }
  }
  useEffect(() => {
    if (profileUpdate.status) {
      setIsChanged(false)
      //@ts-ignore
      dispatch(ProfileAction())
    }
  }, [profileUpdate.status])

  useEffect(() => {
    if (profile?.status) {
      setValue('name', profile?.data?.data?.name)
      setValue('email', profile?.data?.data?.email)
      setValue('phone_number', profile?.data?.data?.phone_number)
      setValue('phone_country_code', profile?.data?.data?.phone_country_code)
      setShowImage(profile?.data?.data?.profile_pic)
      setInitialData({
        name: profile?.data?.data?.name?.trim() || "",
        email: profile?.data?.data?.email || "",
        phone_number: profile?.data?.data?.phone_number || "",
        phone_country_code: profile?.data?.data?.phone_country_code || "",
        profile_pic: profile?.data?.data?.profile_pic || ""
      });
    }
  }, [profile.status])

  useEffect(() => {
    if (watch('email') != profile?.data?.data?.email) {
      setVerfiy(true)
    } else {
      setVerfiy(false)
    }
  }, [watch('email')])

  const selectFileHandler = (e: any) => {
    const getextention = e?.target?.files[0]?.name.split('.').pop()
    if (imageExtentionSupport?.includes(getextention)) {
      e.preventDefault();
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }
      setImage(files[0])
      const reader = new FileReader();
      reader.onload = () => {
        setShowImage(reader.result as any);
      };
      reader.readAsDataURL(files[0]);
    } else {
      e.preventDefault();
      toast.error("Please upload valid image");
      return;
    }
  };


  const handlePhoneNumber = (value: any, code: any, phone: any) => {
    const country_code = `+${value}`
    setValue('phone_country_code', country_code);
  }

  const SendVerfiyOtp = () => {
    if (watch('email')) {
      const payload = {
        email: watch('email')
      }
      VerifyEmail.makeRequest({ payload, type: ApiTypes.POST, url: ApiConstants?.VerifyEmail, toastStatus: true })
    } else {
      toast.error(LanguageConstants?.EMAIL_ADDRESS)
    }
  }
  useEffect(() => {
    if (VerifyEmail.status) {
      setOtpShow(true)
    }
  }, [VerifyEmail.status])


    // Check if form changed
  useEffect(() => {
    if (!initialData) return;
    const currentData :any = {
      name: watch('name')?.trim() || "",
      email: watch('email') || "",
      phone_number: watch('phone_number') || "",
      phone_country_code: watch('phone_country_code') || "",
      profile_pic: image || showimage || ""
    };
    const changed = Object.keys(initialData).some(
      key => initialData[key] !== currentData[key]
    );
    setIsChanged(changed);
  }, [watch('name'), watch('email'), watch('phone_number'), watch('phone_country_code'), image, showimage, initialData]);

  return (
    <>
      {profile?.loading || profileUpdate?.loading || VerifyEmail?.loading ? <FrontLoader /> : null}
      <main>
        {/* top banner section start */}
        <section className="main-banner small-banner" style={{ background: `url(${profileBanner}) center/cover` }}>
          <div className="container">
            <h1 className="small-banner-heading">{LanguageConstants?.MY_PROFILE}<span>{LanguageConstants?.MY_PROFILE}</span></h1>
            {/* <a href="#" class="com-btn">Request a Quote <i class="icon-arrow-up-right"></i></a> */}
          </div>
        </section>
        {/* top banner section end */}
        <div className="container">
          <div className="profile-area footer-space">
            <form onSubmit={handleSubmit(onSubmit)} >
              <div className="profile-img-row" >
                <input className="d-none" id="chooseProfileImage" type="file" onChange={(e) => selectFileHandler(e)} />
                <label className="pro-img-show" htmlFor="chooseProfileImage">
                  {showimage ?
                    <img src={showimage} alt='profile' />
                    : null}
                  {!showimage ?
                    <i className="icon-upload" />
                    : null}
                </label>
                <div className="row">
                  <div className="col-md-10 col-lg-9 col-xl-9">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="com-floating">
                          <i className="f-icon icon-user" />
                          <label className="f-label">{LanguageConstants?.NAME} <span className="must-star">*</span></label>
                          <input className="f-input" type="text" placeholder={`${LanguageConstants?.ENTER_FULL_NAME}`}  {...register('name')} />
                        </div>
                        <ErrorMessage
                          errors={errors}
                          name="name"
                          render={({ message }) => <p className='text-error'>{message}</p>}
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="com-floating">
                          <i className="f-icon icon-msg" />
                          <label className="f-label">{LanguageConstants?.EMAIL_ID}<span className="must-star">*</span></label>
                          <input className="f-input" type="email" placeholder={`${LanguageConstants?.ENTER_EMAIL_ID}`}  {...register('email')} disabled={profile?.data?.data?.social_id ? true : false} />

                          {verfiy ?
                            <i className='icon-tick-2 verify-input-icon' style={{ cursor: 'pointer' }} onClick={() => SendVerfiyOtp()} ></i>
                            : null}
                        </div>
                        <ErrorMessage
                          errors={errors}
                          name="email"
                          render={({ message }) => <p className='text-error'>{message}</p>}
                        />
                      </div>
                      <div className="col-md-6">
                        <div className='wrap-phn-code'>
                          <CommanPhoneNumber handleMobileNumber={handlePhoneNumber} value={watch('phone_country_code')} />
                          <input className='wrap-phn-input' type="text" {...register('phone_number')} />
                        </div>
                        <ErrorMessage
                          errors={errors}
                          name="phone_number"
                          render={({ message }) => <p className='text-error'>{message}</p>}
                        />

                        {/* <div className="com-floating">
                  <i className="f-icon icon-user" />
                  <label className="f-label">Mobile number <span className="must-star">*</span></label>
                  <input className="f-input" type="text" placeholder="Enter Mobile number"  />
                </div> */}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 col-xxl-4">
                  {isChanged ?
                  <button type="submit" className="round-btn w-100 update-pro-btn" onClick={() => handleSubmit(onSubmit)} >{LanguageConstants?.UPDATE_PROFILE}</button>
                   :null}
                  </div>
              </div>
            </form>
          </div>
        </div>
      </main>

      <Modal show={otpShow} >

        <VerfiyOtpEmail show={otpShow} setOtpShow={setOtpShow} email={watch('email')} setVerfiy={setVerfiy} />

      </Modal>

    </>
  )
}

export default Profile